import { Component, Input, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  @Input() text: string = 'Default tooltip text';
  @Input() position: 'top' | 'bottom' = 'top';
  @Input() positionChange: boolean = false;
  isVisible: boolean = false;

  private hideTimeout: any;
  private clickOutsideTimeout: any;

  constructor(private elRef: ElementRef) {}

  showTooltip(duration: number = 5) { 
    this.isVisible = true;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.hideTimeout = setTimeout(() => {
      this.isVisible = false;
    }, duration * 1000); 
  }

  hideTooltip() {
    this.isVisible = false;
    if (this.clickOutsideTimeout) {
      clearTimeout(this.clickOutsideTimeout);
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent) {
    if (this.isVisible && !this.elRef.nativeElement.contains(event.target)) {
      if (this.clickOutsideTimeout) {
        clearTimeout(this.clickOutsideTimeout);
      }
      this.clickOutsideTimeout = setTimeout(() => {
        this.hideTooltip();
      }, 200);
    }
  }
}
